import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const COMPANY_GROUP_BY_UUID_RESOURCE = "company-group" as const;
export const COMPANY_GROUP_BY_UUID_API_PATH = `/v1/${COMPANY_GROUP_BY_UUID_RESOURCE}/{uuid}` as const;

export type CompanyGroupByUuidParameters = paths[typeof COMPANY_GROUP_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type CompanyGroupByUuidResponse =
  paths[typeof COMPANY_GROUP_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCompanyGroupByUuidQuery(uuid: string, options?: Options<CompanyGroupByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<CompanyGroupByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [COMPANY_GROUP_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CompanyGroupByUuidResponse>(
        `/v1/${COMPANY_GROUP_BY_UUID_RESOURCE}/${uuid}`,
        { params: requestParameters },
      );
      return response.data;
    },
  });
}
